import { render, staticRenderFns } from "./NearbyHotelCardComponent.vue?vue&type=template&id=4b4c0aec&scoped=true"
import script from "./NearbyHotelCardComponent.vue?vue&type=script&lang=js"
export * from "./NearbyHotelCardComponent.vue?vue&type=script&lang=js"
import style0 from "./NearbyHotelCardComponent.vue?vue&type=style&index=0&id=4b4c0aec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4c0aec",
  null
  
)

export default component.exports